import React, { useEffect, useState } from "react";
import { generateMessengerKey, generateMessengerUrl } from "sources/profile/user";

const MessengerSettings = (props) => {
    const [alertMessage, setAlertMessage] = useState("");
    const [messengerUrl, setMessengerUrl] = useState("");
    const [loading, setLoading] = useState(true);

    const getUrl = () => {
        generateMessengerUrl({ userId: props.id }).then((res) => {
            setLoading(false);
            if (res) {
                setMessengerUrl(res.url);
            }
        });
    };

    useEffect(() => {
        getUrl();
    }, []);

    const generateKey = () => {
        setLoading(true);
        setAlertMessage("");
        generateMessengerKey({ userId: props.id }).then(getUrl);
    };

    const copyUrl = () => {
        setAlertMessage(
            <>
                Ссылка успешно скопирована
                <br />
                Каждая ссылка уникальна и предназначена для конкретного водителя
            </>,
        );
        navigator.clipboard.writeText(messengerUrl);
    };

    return (
        <div className={loading ? "loading" : ""}>
            {alertMessage && (
                <div className="alert alert-info">
                    <small>{alertMessage}</small>
                </div>
            )}
            <div className="input-group mb-3">
                <input
                    disabled
                    type="text"
                    className="form-control form-control-sm"
                    defaultValue={messengerUrl}
                    placeholder="Сгенерируйте ключ для получения ссылки"
                />
                <div className="input-group-append">
                    <button className="btn btn-brand btn-sm" type="button" onClick={copyUrl}>
                        Скопировать
                    </button>
                </div>
            </div>
            <div className="btn btn-sm btn-secondary" onClick={generateKey}>
                Обновить ключ
            </div>
        </div>
    );
};

export default MessengerSettings;
